/** @format */

import { Provider } from "react-redux";
import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";

import store from "../../redux/store";
import NotFound from "../notfound/NotFound";
import MainLayout from "./layout/MainLayout";
import Dashboard from "./pages/Dashboard/Dashboard";
import { user_data } from "../../components/functions/usr";
import AsosiymanbalarSahifa from "./pages/asosiymanbalar/AsosiyManbalar";

function Index() {
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const itb = user_data() ? user_data().itb_id : 1;

  return (
    <Provider store={store}>
      <Routes>
          <Route element={<MainLayout date={date} setDate={setDate} />}>

            <Route index element={<Dashboard itbId={itb} date={date} />} />
            <Route path='asosiymanbalar/*' element={<AsosiymanbalarSahifa />} />

          </Route>
          <Route path='*' element={<NotFound />} />
      </Routes>
    </Provider>
  );
}

export default Index;
